// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d243ef4","732":"f661833b","977":"7f7ce83a"}[chunkId] + ".chunk.js";
};